/**
 * 页面埋点文件
 */
 import util from '@/tools/utils'        // 工具方法

/**
 * 点击事件
 * @param name
 * @param multi
 */
function trackClick (name, multi) {
  var param
  if (!multi) {
    param = 'action=' + name
  } else {
    param = name
  }
  if (window.trackClick) {
    window.trackClick && window.trackClick(param)
  } else {
    util.loadJs({url: '//static.daojia.com/bi/buried_point/js/tracker.js'}).then(_ => {
      window.trackClick && window.trackClick(param)
    })
  }
}

/**
 * 点击事件
 * @param params
 */
function trackAction(params) {
  var _params = ''
  if (util.isObject(params)) {
    for (var key in params) {
      _params += key + '=' + params[key] + '&'
    }
    _params = _params.substring(0, _params.length - 1)
  } else {
    _params = params
  }
  trackClick(_params, true)
}


// 页面PV
function trackPageview (name) {
  if (window.trackClick) {
    window.trackPageview && window.trackPageview({'router': name})
  } else {
    util.loadJs({url: '//static.daojia.com/bi/buried_point/js/tracker.js'}).then(_ => {
      window.trackPageview && window.trackPageview({'router': name})
    })
  }
}

// 页面PV，传入对象
function trackPageviewObject (obj) {
  if (window.trackClick) {
    window.trackPageview && window.trackPageview(obj)
  } else {
    util.loadJs({url: '//static.daojia.com/bi/buried_point/js/tracker.js'}).then(_ => {
      window.trackPageview && window.trackPageview(obj)
    })
  }
}

export {
  trackClick,
  trackAction,
  trackPageview,
  trackPageviewObject
}



// WEBPACK FOOTER //
// ./src/tools/track.js